import { removeUserBrowser } from 'lib/BrowserStorage'

import {
  Company,
  Document,
  Project,
  StripeProducts,
  TemplateDocument,
  User,
} from 'types'
import { sortStripeProducts } from 'utils/sortStripeProducts'

export const PERSIST_DOCUMENTS = 'PERSIST_DOCUMENTS'
export const persistDocuments = (documents: Document[]) => ({
  payload: documents,
  type: PERSIST_DOCUMENTS,
})

export const PERSIST_DIRECTORIES = 'PERSIST_DOCUMENTS'
export const persistDirectories = (documents: Document[]) => ({
  payload: documents,
  type: PERSIST_DIRECTORIES,
})

export const PERSIST_TEMPLATE_DOCUMENTS = 'PERSIST_TEMPLATE_DOCUMENTS'
export const persistTemplateDocuments = (
  templateDocuments: TemplateDocument[],
) => ({
  payload: templateDocuments,
  type: PERSIST_TEMPLATE_DOCUMENTS,
})

export const REMOVE_TEMPLATE_DOCUMENTS = 'REMOVE_TEMPLATE_DOCUMENTS'
export const removeTemplateDocuments = (
  templateDocuments: TemplateDocument[],
) => ({
  payload: templateDocuments,
  type: REMOVE_TEMPLATE_DOCUMENTS,
})

export const PERSIST_PROJECTS = 'PERSIST_PROJECTS'
export const persistProjects = (projects: Project[]) => ({
  payload: projects,
  type: PERSIST_PROJECTS,
})

export const PERSIST_COMPANIES = 'PERSIST_COMPANIES'
export const persistCompanies = (companies: Company[]) => ({
  payload: companies,
  type: PERSIST_COMPANIES,
})
export const PERSIST_OTHER_ROLES = 'PERSIST_OTHER_ROLES'
export const persistOtherRoles = (roles: any) => ({
  payload: roles,
  type: PERSIST_OTHER_ROLES,
})

export const ADD_PERMISSIONS = 'ADD_PERMISSIONS'
export const addPermissions = (permissions: any) => ({
  payload: permissions,
  type: ADD_PERMISSIONS,
})

export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'
export const updatePermissions = (permission: any) => ({
  payload: permission,
  type: UPDATE_PERMISSIONS,
})

export const ADD_DIRECTORIES = 'ADD_DIRECTORIES'
export const addDirectories = (directories: any) => ({
  payload: directories,
  type: ADD_DIRECTORIES,
})

export const ADD_NOTICE = 'ADD_NOTICE'
export const addNotice = (notice: string) => ({
  payload: notice,
  type: ADD_NOTICE,
})

export const ADD_ERROR = 'ADD_ERROR'
export const addError = (error: string) => ({
  payload: error,
  type: ADD_ERROR,
})

export const REMOVE_ERRORS = 'REMOVE_ERRORS'
export const removeErrors = () => ({
  type: REMOVE_ERRORS,
})

export const REMOVE_USER = 'REMOVE_USER'
export const removeUser = () => {
  removeUserBrowser()
  return {
    type: REMOVE_USER,
  }
}

export const PERSIST_USER = 'PERSIST_USER'
export const persistUser = (user: User) => {
  return {
    payload: { user },
    type: PERSIST_USER,
  }
}

export const PERSIST_PRODUCTS = 'PERSIST_PRODUCTS'
export const persistProducts = (products: StripeProducts) => {
  const sortedProducts = sortStripeProducts(products)
  return {
    payload: sortedProducts,
    type: PERSIST_PRODUCTS,
  }
}
